import { render, staticRenderFns } from "./ExCreateUserWizard.vue?vue&type=template&id=242404c4&scoped=true"
import script from "./ExCreateUserWizard.vue?vue&type=script&lang=js"
export * from "./ExCreateUserWizard.vue?vue&type=script&lang=js"
import style0 from "./ExCreateUserWizard.vue?vue&type=style&index=0&id=242404c4&prod&scoped=true&lang=css"
import style1 from "./ExCreateUserWizard.vue?vue&type=style&index=1&id=242404c4&prod&lang=css"


/* normalize component */
import normalizer from "!../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242404c4",
  null
  
)

export default component.exports